module.exports = __webpack_public_path__ + "static/media/absensi_ekskul.c33d2ecb.png";